import { all, call, takeEvery, takeLatest, put } from 'redux-saga/effects';
import toaster from '../views/components/toast';
import * as uiActions from '../actions/Actions';
import history from '../history';

const redirectToLogin = () => {
    history.push('/login');
};

export function* showToast({ message, kind }) {
    yield call(toaster.notify, message, { kind });
}

export function* handleUnauthorizedRequest() {
    yield call(redirectToLogin);
    yield put(uiActions.logout());
    yield put(
        uiActions.showAlert('You’ve been logged out, because your session had expired.', 'negative')
    );
}

// A 403 means the session is valid and the action was refused (M7-477).
// Deliberately does NOT redirect, log out, or claim the session expired — the
// user stays exactly where they are and is told what actually happened.
export function* handleForbiddenRequest() {
    yield put(
        uiActions.showAlert(
            'You don’t have permission to do that. Contact an administrator if you need access.',
            'negative'
        )
    );
}

export default function* root() {
    yield all([
        takeEvery(['SHOW_TOAST'], showToast),
        takeLatest(['API_REQUEST_UNAUTHORIZED_ERROR'], handleUnauthorizedRequest),
        takeLatest(['API_REQUEST_FORBIDDEN_ERROR'], handleForbiddenRequest),
    ]);
}
